export default __webpack_public_path__ + "static/media/branding-logo.d5d5156c.svg";